<template>
  <FormItem v-bind="itemProp">
    <FormItem :error="error">
      <div class="flex">
        <Input v-model="keyword" @input="error = ''" @on-enter="addKeyword" placeholder="多个关键词用分号（;）分割，按回车确认" />
        <Button type="primary" style="margin-left: 10px" @click="copyTextToClipboard(arrayToText(value))">复制</Button>
        <Button type="primary" style="margin-left: 10px" @click="close()">清空</Button>
        <Button type="success" style="margin-left: 10px" @click="$emit('open-ai')">泛化</Button>
      </div>
    </FormItem>
    <keyword-hint :style="{marginTop: '15px'}" :sysKeys="sysKeys" :keywords="value" @change="input" closable/>
  </FormItem>
</template>

<script>
import KeywordHint from './KeywordHint.vue'
export default {
  components: { KeywordHint },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
    sysKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      keyword: '',
      error: '',
    };
  },
  computed: {
    itemProp() {
      return {
        label: '关键词',
        ...this.formItemProps,
      }
    }
  },
  methods: {
    arrayToText(value) {
      // 把,改成\\,
      return value.map(item => item.replace(/;/g, '\\;')).join(';')
    },
    addKeyword() {
      const keywordData = this.verify(this.keyword);
      const value = keywordData.correct;
      if (keywordData.error) {
        this.error = '表达式格式错误'
      }
      if (value.length === 0) return;
      const oldVal = this.value || [];
      const newVal = [...(new Set([...oldVal, ...value]))];
      this.keyword = keywordData.error;
      this.input(newVal);
    },
    // 校验
    verify(sentennce) {
      let sentences = []
      try {
        sentences = sentennce.split(/(?<![\\]);/).map(item => item.replace(/\\;/g, ';'));
      } catch (error) {
        sentences = [sentennce]
      }
      const res = sentences.reduce((item, key) => {
        if (!key) return item;
        try {
          new RegExp(key)
          item.correct.push(key)
        } catch (error) {
          item.error.push(key)
        }
        return item;
      }, { correct: [], error: [] })
      return {
        correct: res.correct,
        error: res.error.join(' '),
      }
    },
    input(value) {
      this.$emit('input', value)
    },
    close() {
      this.$emit('input', [])
    },
    copyTextToClipboard(text) {
      const textArea = document.createElement('textarea');

      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;

      textArea.style.width = '2em';
      textArea.style.height = '2em';

      textArea.style.padding = 0;

      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';

      textArea.style.background = 'transparent';
  
      textArea.value = text;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        if (successful) {
          this.$Message.success('复制成功');
        }
      } catch (err) {
        console.log('Oops, unable to copy');
      }

      document.body.removeChild(textArea);
    },
  },

}
</script>
